const carouselItems = [
  {
    title: '2026娱乐圈大洗牌',
    desc: '多位顶流艺人接连塌房，娱乐圈格局正在重塑。完整梳理今年最轰动的黑料事件。',
    tag: '焦点追踪',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20spotlight%20on%20empty%20theater%20stage%20with%20red%20curtains%2C%20mysterious%20entertainment%20atmosphere%2C%20cinematic%20lighting%2C%20low%20key%20photography%2C%20no%20people%2C%20warm%20dark%20tones%2C%20abstract%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '互联网大厂权力游戏',
    desc: '从高管变动到内部斗争，揭秘头部互联网公司不为人知的权力博弈和利益分配。',
    tag: '深度揭秘',
    img: 'https://readdy.ai/api/search-image?query=Dark%20modern%20glass%20office%20building%20at%20night%2C%20dramatic%20lighting%20through%20windows%2C%20mysterious%20corporate%20atmosphere%2C%20low%20key%20photography%2C%20no%20people%2C%20cinematic%20mood%2C%20warm%20undertones&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '直播带货江湖暗战',
    desc: '头部主播之间的竞争已从屏幕延伸到线下，一条条黑料揭开流量时代的残酷真相。',
    tag: '独家整理',
    img: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20professional%20lighting%20equipment%2C%20empty%20streaming%20setup%2C%20dramatic%20red%20accent%20lights%2C%20mysterious%20digital%20atmosphere%2C%20low%20key%20photography%2C%20no%20people%2C%20abstract%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '体育圈黑料频发真相',
    desc: '从转会黑幕到裁判争议，体育圈背后的利益链条正在被一条条黑料逐层揭开。',
    tag: '持续追踪',
    img: 'https://readdy.ai/api/search-image?query=Dark%20empty%20sports%20arena%20with%20dramatic%20spotlight%2C%20mysterious%20atmosphere%2C%20cinematic%20sports%20photography%2C%20low%20key%20lighting%2C%20no%20people%2C%20warm%20dark%20tones%2C%20abstract%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '学术圈造假风暴蔓延',
    desc: '多所高校接连爆出学术不端事件，从论文抄袭到数据造假，学术诚信面临拷问。',
    tag: '热点聚焦',
    img: 'https://readdy.ai/api/search-image?query=Dark%20empty%20library%20or%20archive%20room%20at%20night%2C%20dramatic%20single%20light%20source%2C%20mysterious%20academic%20atmosphere%2C%20low%20key%20photography%2C%20no%20people%2C%20cinematic%20mood%2C%20warm%20undertones&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          当前最值得关注的深度黑料专题报道
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`group relative bg-background-50 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-500/30 ${
                i < 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-background-50/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block text-xs font-medium text-primary-400 bg-primary-500/15 px-2.5 py-0.5 rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-50 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}